import RootStore from '../RootStore';
import {
  action,
  computed,
  makeObservable,
  observable,
  runInAction,
} from 'mobx';
import { InquiryApi } from '../../api/inquiry.api';
import { ReservationDetail } from '../../interfaces/partner-dependent/inquiry-target';
import moment from 'moment';
import { IRecipient } from '../../interfaces/user.interface';
import { SsiApi } from '../../api/ssi.api';
import { IService } from '../../interfaces/service.interface';

export const DEFAULT_RESERVATION_ID: string = 'default';

export default class TravelStore {
  // for definition, see:
  // https://confluence.rakuten-it.com/confluence/display/MSP/Cassandra+-+service
  SERVICE_ID = 1003;
  SERVICE_ATTRIBUTE = 104;

  rootStore: RootStore;
  @observable targetDetail: ReservationDetail | undefined = {
    reservationId: DEFAULT_RESERVATION_ID,
    hotelImageUrl: '',
    checkInDate: '',
    checkInTime: '',
    planName: '-',
    roomType: '-',
  };
  @observable headerHtml: string = '';
  @observable footerHtml: string = '';
  @observable staticLinkTag: string = '';

  @computed
  get isReadyToRender(): boolean {
    return !!(this.headerHtml && this.footerHtml && this.staticLinkTag);
  }

  @action
  async getSsiContents(service: IService) {
    this.getStaticHtml(service);
    this.getHeaderHtml(service);
    this.getFooterHtml(service);
  }

  private async getStaticHtml(service: IService) {
    await runInAction(async () => {
      this.staticLinkTag = await SsiApi.getStaticHtml(
        service.serviceId,
        service.serviceAttribute,
      );
    });
  }

  private async getHeaderHtml(service: IService) {
    await runInAction(async () => {
      this.headerHtml = await SsiApi.getHtmlFromSsiUrl(
        service.serviceId,
        service.serviceAttribute,
        service.htmlUrl['header'],
      );
    });
  }

  private async getFooterHtml(service: IService) {
    await runInAction(async () => {
      this.footerHtml = await SsiApi.getHtmlFromSsiUrl(
        service.serviceId,
        service.serviceAttribute,
        service.htmlUrl['footer'],
      );
    });
  }

  @computed
  get targetDetailForView() {
    // return {
    //   reservationId: 'RYa061ekwb',
    //   imgUrl: 'https://img.travel.rakuten.co.jp/image/imgr_90?no=101459',
    //   checkInDate: '2022-11-24',
    //   roomType: '【部屋】部屋売り',
    // };
    const checkinDateTime = moment(
      this.targetDetail?.checkInDate + ' ' + this.targetDetail?.checkInTime,
      'YYYY-MM-DD HH:mm',
    );

    return this.targetDetail?.reservationId === DEFAULT_RESERVATION_ID
      ? []
      : [
          {
            columnName: 'チェックイン',
            value: `${
              checkinDateTime.isValid()
                ? checkinDateTime.format('YYYY-MM-DD(ddd) HH:mm')
                : '-'
            }`,
          },
          {
            columnName: '宿泊プラン',
            // value: `${this.reservationDetail?.planName}`,
            // 宿泊プラン can be null. then show empty value instead.
            value: this.targetDetail?.planName || '-',
            // '【クチコミ・4.5以上】大浴場×サウナでととのう！ドーミーインスタンダードプラン!!＜素泊まり＞',
          },
          {
            columnName: '部屋タイプ',
            value: `${this.targetDetail?.roomType || '-'}`,
            // value:
            // '禁煙エアウィーヴダブルルーム(ベッド1台・140×195)\n' +
            // eslint-disable-next-line no-irregular-whitespace
            // '（大人1名・お子様1名様まで　14平米☆サータ社製ベット(140×195)☆男女別大浴場完備☆シャワーブース☆Wi-Fi完備）',
          },
        ];
  }

  @action
  setTargetDetail = async (recipient: IRecipient, targetId: string) => {
    try {
      await runInAction(async () => {
        this.targetDetail = await InquiryApi.searchTargets(
          recipient.serviceId,
          recipient.serviceAttribute,
          recipient.authId,
          targetId!,
        );
      });
    } catch (e) {
      console.error(e);
      window.location.href = '/inconsistent';
    }
  };

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);
  }
}
